var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValuation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 272,
    viewBox: "0 0 250 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddddd_2_108)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 2,
    width: 90,
    height: 90,
    rx: 20,
    fill: "#4DDFFD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.937 58.4923L118.419 60L113 54.7577L116.882 50.9311C117.669 50.1505 118.661 49.6059 119.745 49.3599C120.829 49.114 121.961 49.1767 123.01 49.5408L123.863 49.8367H129.097C129.319 49.8366 129.538 49.8807 129.742 49.9663C129.945 50.0519 130.13 50.1773 130.284 50.3351C130.438 50.4928 130.559 50.6797 130.639 50.8847C130.719 51.0896 130.756 51.3084 130.749 51.5281C130.724 51.9623 130.531 52.37 130.21 52.6662C129.889 52.9623 129.466 53.124 129.028 53.1173H125.888C125.718 53.1173 125.554 53.1845 125.434 53.3041C125.313 53.4237 125.246 53.586 125.246 53.7551C125.246 53.9242 125.313 54.0865 125.434 54.2061C125.554 54.3257 125.718 54.3929 125.888 54.3929H129.038C129.806 54.3966 130.547 54.1068 131.106 53.5835C131.665 53.0602 132 52.3434 132.042 51.5816C132.042 51.5689 132.042 51.5561 132.042 51.5408L134.955 48.2832C135.251 47.9422 135.668 47.7275 136.12 47.6838C136.571 47.6401 137.022 47.7707 137.378 48.0485C137.555 48.1936 137.7 48.3724 137.806 48.5743C137.912 48.7762 137.976 48.997 137.994 49.2239C138.013 49.4507 137.985 49.6789 137.914 49.895C137.842 50.1111 137.727 50.3108 137.576 50.4821L131.759 57.1148C131.375 57.5517 130.901 57.9017 130.369 58.1411C129.837 58.3806 129.26 58.5038 128.676 58.5026L119.937 58.4923ZM131.949 44.0714C131.949 43.7501 131.821 43.4418 131.592 43.2146C131.363 42.9874 131.052 42.8597 130.729 42.8597H128.93V41.074C128.916 40.7626 128.781 40.4686 128.554 40.2533C128.327 40.038 128.025 39.9178 127.711 39.9178C127.397 39.9178 127.095 40.038 126.868 40.2533C126.641 40.4686 126.506 40.7626 126.492 41.074V42.8597H124.693C124.528 42.8522 124.364 42.8779 124.209 42.9354C124.055 42.9928 123.914 43.0808 123.794 43.1939C123.675 43.307 123.58 43.443 123.515 43.5936C123.45 43.7442 123.417 43.9063 123.417 44.0702C123.417 44.234 123.45 44.3961 123.515 44.5467C123.58 44.6973 123.675 44.8333 123.794 44.9464C123.914 45.0596 124.055 45.1475 124.209 45.2049C124.364 45.2624 124.528 45.2881 124.693 45.2806H126.492V47.0663C126.506 47.3777 126.641 47.6717 126.868 47.887C127.095 48.1023 127.397 48.2225 127.711 48.2225C128.025 48.2225 128.327 48.1023 128.554 47.887C128.781 47.6717 128.916 47.3777 128.93 47.0663V45.2806H130.729C131.052 45.2806 131.362 45.1533 131.591 44.9266C131.82 44.6999 131.949 44.3924 131.949 44.0714ZM120.248 37.3571V38.6735H118.925C118.686 38.6735 118.458 38.7675 118.289 38.935C118.12 39.1024 118.026 39.3295 118.026 39.5663C118.026 39.8031 118.12 40.0302 118.289 40.1977C118.458 40.3651 118.686 40.4592 118.925 40.4592H120.251V41.7755C120.251 42.0123 120.346 42.2394 120.514 42.4069C120.683 42.5743 120.912 42.6684 121.15 42.6684C121.389 42.6684 121.617 42.5743 121.786 42.4069C121.955 42.2394 122.049 42.0123 122.049 41.7755V40.4541H123.367C123.606 40.4541 123.835 40.36 124.003 40.1926C124.172 40.0251 124.267 39.798 124.267 39.5612C124.267 39.3244 124.172 39.0973 124.003 38.9299C123.835 38.7624 123.606 38.6684 123.367 38.6684H122.042V37.3571C122.042 37.1203 121.947 36.8932 121.778 36.7258C121.61 36.5584 121.381 36.4643 121.142 36.4643C120.904 36.4643 120.675 36.5584 120.506 36.7258C120.338 36.8932 120.243 37.1203 120.243 37.3571H120.248ZM131.592 35C131.388 35 131.192 35.0806 131.047 35.2242C130.902 35.3677 130.821 35.5623 130.821 35.7653V36.898H129.68C129.476 36.898 129.28 36.9786 129.135 37.1221C128.991 37.2656 128.91 37.4603 128.91 37.6633C128.91 37.8662 128.991 38.0609 129.135 38.2044C129.28 38.3479 129.476 38.4286 129.68 38.4286H130.821V39.5612C130.821 39.7642 130.902 39.9589 131.047 40.1024C131.192 40.2459 131.388 40.3265 131.592 40.3265C131.797 40.3265 131.993 40.2459 132.137 40.1024C132.282 39.9589 132.363 39.7642 132.363 39.5612V38.4286H133.504C133.605 38.4286 133.705 38.4088 133.799 38.3703C133.892 38.3319 133.977 38.2755 134.049 38.2044C134.12 38.1334 134.177 38.049 134.216 37.9561C134.255 37.8633 134.275 37.7638 134.275 37.6633C134.275 37.5628 134.255 37.4632 134.216 37.3704C134.177 37.2775 134.12 37.1932 134.049 37.1221C133.977 37.051 133.892 36.9947 133.799 36.9562C133.705 36.9178 133.605 36.898 133.504 36.898H132.363V35.7653C132.363 35.5623 132.282 35.3677 132.137 35.2242C131.993 35.0806 131.797 35 131.592 35Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_2_108",
    x: 0,
    y: 0.703704,
    width: 250,
    height: 271.296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.85185
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.57407
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.301961 0 0 0 0 0.87451 0 0 0 0 0.992157 0 0 0 0.0168519 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_108"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.14815
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.25926
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.301961 0 0 0 0 0.87451 0 0 0 0 0.992157 0 0 0 0.0274815 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2_108",
    result: "effect2_dropShadow_2_108"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.301961 0 0 0 0 0.87451 0 0 0 0 0.992157 0 0 0 0.035 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2_108",
    result: "effect3_dropShadow_2_108"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 38.5185
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.7407
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.301961 0 0 0 0 0.87451 0 0 0 0 0.992157 0 0 0 0.0425185 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2_108",
    result: "effect4_dropShadow_2_108"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 64.8148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.4259
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.301961 0 0 0 0 0.87451 0 0 0 0 0.992157 0 0 0 0.0531481 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_2_108",
    result: "effect5_dropShadow_2_108"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 100
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.301961 0 0 0 0 0.87451 0 0 0 0 0.992157 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_2_108",
    result: "effect6_dropShadow_2_108"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_2_108",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuation);
export default __webpack_public_path__ + "static/media/Valuation.66f30a5c74dd394c51de4f5a915d4423.svg";
export { ForwardRef as ReactComponent };